// extracted by mini-css-extract-plugin
export default {"header":"Header_header__j0t06","brand-logo":"Header_brand-logo__QCYDq","header-separator":"Header_header-separator__2HdXz"};